import React from "react";
import Button from "@components/Button";
import Link from "@components/Link";
import Image from "@components/Image";
import cx from "classnames";
import styles from "./Article.module.scss";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StoryArticleService/getter";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";
const View = ({ light = false }: any) => {
  const { articles } = usePageContext();
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <div className={cx("article-box", { [`light`]: light })}>
      {_.map(articles, (article, index) => (
        <Link
          href={router.toUrl("storiesArticle", { slug: getter.slug(article) })}
          className={cx("article", styles.article)}
          key={`article_${index}`}
          scroll={true}
          // onClick={() => onClick(article)}
        >
          <Image
            wrapperProps={{ className: cx("image", styles.image) }}
            src={getter.image(article).src}
            alt={getter.image(article).alt}
          />

          <div className={cx("box", styles.box)}>
            <div>
              <div className={cx("category", styles.category)}>
                {getter.category(article).name}
              </div>
              <h2 className={cx("title", styles.title)}>
                {getter.title(article)}
              </h2>
              <div className={cx("description", styles.description)}>
                {getter.description(article)}
              </div>
            </div>
            <Button
              type="icon"
              suffix="shape-arrow"
              className={cx("button", styles.button)}
            >
              {i18n.t("Button.readMore")}
            </Button>
          </div>
        </Link>
      ))}
    </div>
  );
};
export default View;
